import urlFile from "../common/ApiFile"
import url from "../common/api"
import {getQueries} from "../queries/getQueries.js"
import {postQueries} from "../queries/postQueries"
import {patchQueries} from "../queries/patchQueries"



// export  getLangue

export async function removeElement(data,url){
    var datas={}
    await postQueries(url,data).then(res=>{
        datas=res
    })
    return await datas
}

export async function removeElements(data,url){
    var datas={}
    for(var i=0;i<data.length;i++){
    await postQueries(url,data[i]).then(res=>{
       
    })
   }
    
}

export async function getExpertByProfile(data){
    var datas=[]
    await postQueries("utilisateur/getExpertByProfile",data).then(async (res)=>{
        datas=res
        if(localStorage.getItem("private_id") && localStorage.getItem("private_id")!==data?.profile_id ){
            await getQueries("profiles/"+localStorage.getItem("private_id")).then(data2=>{
                let data_ress=res.concat(data2?.utilisateurs)
                datas=_.uniqBy(data_ress,"id")
                
            })
          }
       
    })
   return await datas
}

export async function getExpertBySearch(data){
    var datas=[]
    await postQueries("utilisateur/searchExpert",data).then(res=>{
        datas=res
       
    })
   return await datas
}

export async function updateExpert(data){
    var datas={}
    const id=sessionStorage.getItem("idExpert")
    await patchQueries("utilisateurs/"+id,data).then(res=>{
        datas=res
    })
    return await datas
}



export async function removeSousTypeInExpert(sous_types,idExpert){
if(sous_types.length) {
    for(var i=0;i<sous_types.length;i++){
        await postQueries("expert_sous_type/delete",{"utilisateur_id":idExpert,"sous_type_expert_id":sous_types[i].id}).then(res=>{
        
        })
    }
}
     
    
}
  
        